import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function mentorDataReducer(
  state = initialState.mentorsData,
  action
) {
  switch (action.type) {
    case types.LOAD_MENTORS_DATA_SUCCESS:
      return action.mentorsData;
    default:
      return state;
  }
}
